// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".produto-regional-novo #descricao, .produto-regional-novo #CR {\n  text-transform: uppercase; }\n", "",{"version":3,"sources":["webpack://./src/modules/produtoRegional/produtoRegionalNovo.scss"],"names":[],"mappings":"AAAA;EAEK,yBAAyB,EAAA","sourcesContent":[".produto-regional-novo {\n    & #descricao, #CR {\n    \ttext-transform: uppercase;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
